// eslint-disable-next-line import/prefer-default-export
export const INSERT_UPSELL_HIGHLIGHT = 'upsellHighlight/insert'
